import * as React from "react";
import { Link } from "react-router-dom";

import { Container, Message, Grid } from "../semantic-ui";
import { publicUrl, boardUrl } from "../urls";

const HomePage = () => (
  <Container text>
    <h1>Play Chess 2 Online</h1>
    <p>
      Welcome to Chess 2 Online! The website is still young but you can can play
      games online or <Link to={boardUrl()}>play a local hotseat game</Link> on
      your PC or tablet.
    </p>
    <Grid columns={2}>
      <Grid.Column>
        <h2>Join the community</h2>
      </Grid.Column>
      <Grid.Column textAlign="right" verticalAlign="middle">
        <a href="https://www.reddit.com/r/Chess2Online/" target="_blank">
          <img
            alt="Subreddit subscribers"
            src="https://img.shields.io/reddit/subreddit-subscribers/Chess2Online?style=social"
          />
        </a>
      </Grid.Column>
    </Grid>
    <Message info>
      <Message.Header>Announcing the official Subreddit!</Message.Header>
      <p>
        I haven't done any advertising for this site, I mostly built it for
        myself and a friend. Since I put it online, a handful of people have
        found it by themselves and played games! I figured it would be good to
        have a community where people can organize matches with each other, as
        well as provide me with feedback about the site, so I created a
        subreddit,{" "}
        <a href="https://www.reddit.com/r/Chess2Online/" target="_blank">
          /r/Chess2Online
        </a>
        . If you use reddit and want to play Chess 2, consider joining and
        organizing a match!
      </p>
    </Message>
    <h2>What is Chess 2?</h2>
    <p>
      Chess 2 is a variant of chess created by Dave Sirlin. This website is not
      affiliated with Sirlin Games.{" "}
      <a href={publicUrl("/rulebook.pdf")}>A complete rulebook</a> for the game
      is available to download, but the primary differences are:
    </p>
    <p>
      <strong>Win by Midline Invasion.</strong> You can win by checkmate as in
      normal chess, but in addition to that if your king can safely reach the
      5th rank you win the game.
    </p>
    <p>
      <strong>Dueling.</strong> When your piece is captured, you can challenge
      your opponent to a duel. If you win the duel, your piece is still
      captured, but the opponent's piece is also captured. The duel is a secret
      bid using stones. You start the game with 3 stones and gain a stone every
      time you capture an enemy pawn.
    </p>
    <p>
      <strong>Six Armies.</strong> Chess 2 has the classic set of chess pieces,
      but also includes 5 new configurations called armies. Each army
      substitutes some fo the classic pieces for specialized pieces with
      different moves.
    </p>
  </Container>
);

export default HomePage;
